import { type FC } from 'react';
import { ArchiveRestore } from 'lucide-react';
import { ModalId, useOpenModal } from '@/hooks/data/modal/useModalStore';
import { Button } from '@/components/ui/button';
import { NodeType } from '@/types/tree';
import { useTranslations } from 'next-intl';

export const TrashedBanner: FC<{ currentSelectedType: NodeType; disabled?: boolean }> = ({
  currentSelectedType,
  disabled,
}) => {
  const openModal = useOpenModal();
  const tCommon = useTranslations('common');
  const tTrashedBanner = useTranslations('inspector.trashedBanner');

  return (
    <div className="flex items-center justify-between gap-x-2 bg-icon-base px-3 py-2 text-sm text-text-base dark:text-text-inverted">
      {tTrashedBanner('message', {
        type:
          currentSelectedType === NodeType.Assets
            ? 'asset'
            : currentSelectedType === NodeType.Folders
              ? 'folder'
              : 'album',
      })}
      <Button
        disabled={disabled}
        onClick={() => openModal(ModalId.RestoreTrashConfirmation)}
        data-cy="toolbar-restore-item-button"
        className="min-h-8 gap-x-2 rounded-xl bg-text-gray-alternate! py-0 font-bold text-text-base dark:text-text-inverted"
        icon={ArchiveRestore}
        iconClassName="icon-5"
      >
        {tCommon('restore')}
      </Button>
    </div>
  );
};
